import { P } from '../../theme/tokens';
import { LISTING_STATUS } from '../../utils/listings';

export const STATUS = LISTING_STATUS;

export const EMERGENCY = { label: 'Emergency', color: P.danger };

export const STATUS_OPTIONS = ['available', 'turn', 'coming_soon', 'pending', 'leased', 'off_market'].map((value) => ({
  value,
  label: STATUS[value].label
}));

export const USES = [
  { value: 'residential', label: 'Residential' },
  { value: 'commercial', label: 'Commercial' }
];

export const HOME_TYPES = [
  { value: 'apartment', label: 'Apartment' },
  { value: 'house', label: 'House' },
  { value: 'duplex', label: 'Duplex' },
  { value: 'quadplex', label: 'Quadplex' },
  { value: 'townhouse', label: 'Townhouse' },
  { value: 'condo', label: 'Condo' },
  { value: 'mobile_home_lot', label: 'Mobile-home lot' },
  { value: 'room', label: 'Room' }
];

export const SECTION8 = [
  { value: 'ask', label: 'Ask the team' },
  { value: 'yes', label: 'Accepted' },
  { value: 'no', label: 'Not accepted' }
];

export const RESIDENTIAL_TYPES = ['Studio', '1BR / 1BA', '2BR / 1BA', '2BR / 2BA', '3BR / 2BA', '3BR / 3BA', '4BR / 3BA'].map(
  (t) => ({ value: t, label: t })
);

export const COMMERCIAL_TYPES = [
  { value: 'office', label: 'Office' },
  { value: 'retail', label: 'Retail' },
  { value: 'warehouse', label: 'Warehouse' },
  { value: 'industrial', label: 'Industrial' }
];

const COMMERCIAL_LABEL = Object.fromEntries(
  [...COMMERCIAL_TYPES, { value: 'commercial', label: 'Commercial' }].map((t) => [t.value, t.label])
);

export const LANES = [
  { key: 'emergency', ...EMERGENCY },
  { key: 'turn', ...STATUS.turn },
  { key: 'available', ...STATUS.available },
  { key: 'leased', ...STATUS.leased },
  { key: 'off_market', ...STATUS.off_market, optional: true }
];

export const laneOf = (l) =>
  l.work?.urgent
    ? 'emergency'
    : l.status === 'coming_soon'
      ? 'turn'
      : l.status === 'pending' || !STATUS[l.status]
        ? 'available'
        : l.status;

export const statusOf = (l) => (l.work?.urgent ? EMERGENCY : STATUS[l.status] || STATUS.available);

const usd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });

export const formatMoney = (n) => (n == null ? null : usd.format(n));

export const roomsOf = (l) => (l.bedrooms ? `${l.bedrooms}BR / ${l.bathrooms || 0}BA` : 'Studio');

const HOME_LABEL = Object.fromEntries(HOME_TYPES.map((t) => [t.value, t.label]));

export function layoutOf(l) {
  if (l.unitType === 'mobile_home_lot') return HOME_LABEL.mobile_home_lot;
  if (l.use !== 'commercial') return [roomsOf(l), HOME_LABEL[l.unitType]].filter(Boolean).join(' · ');
  return [COMMERCIAL_LABEL[l.unitType], l.sqft && `${l.sqft.toLocaleString('en-US')} sq ft`].filter(Boolean).join(' · ');
}

export const labelOfUse = (l) => USES.find((u) => u.value === l.use)?.label;
